<template>
<div>
<div v-if="lang == 'he'" class="inhonorof inhonorof--heb">
	<FormRow>
  		<input type="checkbox" id="inHonorOf" name="inHonorOf" v-model="inHonorOf"/>
  		<FormLabel for="inHonorOf">הקדש את התרומה שלך</FormLabel>
	</FormRow>
	<div  v-if="inHonorOf" class="honor-container">
		<FormRow inline>
			<FormCol field="dedication">
				 <FormSelect>
				<option value="In honor of">לכבוד</option>
				<option value="In memory of">לזכר</option>
				<option value="For the recovery of">להחלמה של</option>
				</FormSelect>
			</FormCol>
			<FormCol field="honoreeName" />
		</FormRow>
		<FormRow inline>
			<FormCol field="dedicationMessage" />
		</FormRow>
		<FormRow inline v-if="recipientFlag">
			<FormCol field="recipientName" />
			<FormCol field="recipientEmail" />
		</FormRow>
		<FormRow inline v-if="recipent">
			<span class="edit-recipient" @click="()=>{recipientFlag = !recipientFlag}">
				<span v-if="!recipientFlag">+ לְהוֹסִיף </span>
				<span v-else>- להסיר </span>
				מקבל
				<span v-if="!recipientFlag">  להודיע</span>
			</span>
		</FormRow>
	</div>
</div>
<div class="inhonorof" v-else>
	<FormRow>
  		<input type="checkbox" id="inHonorOf" name="inHonorOf" v-model="inHonorOf"/>
  		<FormLabel for="inHonorOf">Dedicate your donation</FormLabel>
	</FormRow>
	<div  v-if="inHonorOf" class="honor-container">
		<FormRow inline>
			<FormCol field="dedication">
				<FormSelect>
				<option value="" disabled selected hidden>Select Dedication</option>
				<option value="In honor of">In honor of</option>
				<option value="In memory of">In memory of</option>
				<option value="For the recovery of">For the recovery of</option>
				</FormSelect>
			</FormCol>
			<FormCol field="honoreeName" />
		</FormRow>
		<FormRow inline>
			<FormCol field="dedicationMessage" label="Message" width="full">
				<FormInput type="textarea" field="dedicationMessage" placeholder="Type your message here..." />
			</FormCol>
		</FormRow>
		<FormRow inline v-if="recipientFlag">
			<FormCol field="recipientName" />
			<FormCol field="recipientEmail" />
		</FormRow>
		<FormRow inline v-if="recipent">
			<span class="edit-recipient" @click="()=>{recipientFlag = !recipientFlag}">
				<span v-if="!recipientFlag">+ Add </span>
				<span v-else>- Remove </span>
				recipient
				<span v-if="!recipientFlag"> to notify</span>
			</span>
		</FormRow>
	</div>
</div>
</div>
</template>
<script lang="ts">
import { defineComponent,  ref, watch } from 'vue'

export default defineComponent({
  props: {
    recipent: {
      type: Boolean,
      default: true
    },
		lang: {
      type: String
    },
    initialOpen: {
      type: Boolean,
      default: false
    },
  },
  setup(props) {
	  const inHonorOf = ref(props.initialOpen)
	  const recipientFlag = ref(false)

	  return {
		  inHonorOf,
		  recipientFlag
	  }
  }
})
</script>
<style scoped lang="scss">
input[type="checkbox"] {
	margin-right: 7px;
}
input#inHonorOf {
	width: 54px;
	height: 25px;
	padding: 0 5px;
	border-radius: 999px;
	background: #9c9697;
	flex: 0 0 54px;
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	margin-right: 8px;
	position: relative;
	cursor: pointer;
	transition: background-color 0.2s ease;
	&::before {
		content: "NO";
		position: absolute;
		top: 50%;
		right: 6px;
		transform: translateY(-50%);
		color: #fff;
		font-size: 11px;
		font-weight: 700;
		line-height: 1;
		letter-spacing: 0.5px;
	}
	&::after {
		content: "";
		width: 19px;
		height: 19px;
		border-radius: 50%;
		background: #fff;
		box-shadow: 0 1px 3px rgb(0 0 0 / 20%);
		position: absolute;
		left: 3px;
		top: 3px;
		transition: transform 0.2s ease;
	}
	&:checked {
		background: #ff9700;
	}
	&:checked::before {
		content: "YES";
		right: auto;
		left: 7px;
	}
	&:checked::after {
		transform: translateX(29px);
	}
	&:focus-visible {
		outline: 2px solid #231f20;
		outline-offset: 2px;
	}
}
.honor-container {
	padding-top: 20px;
	border-top: 1px solid #ddd;
	margin-top: 20px;
}
::v-deep .honor-container textarea {
	min-height: 120px;
	padding: 10px 12px;
}
.flex {
	display: flex;
	align-items: center;
}
.honor-type {
	max-width: 150px;
	min-width: 150px;
	margin-right: 7px;
}
.edit-recipient {
	color: var(--Grayscale-Ash, #160D10);
text-align: center;

/* Desktop/Text/Condensed/Action - Regular */
font-family: "Blinker";
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: 20px; /* 142.857% */
letter-spacing: 3px;
text-transform: uppercase;
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}

}
::v-deep .inhonorof--heb{
	label[for="inHonorOf"]:after {content:"הקדש את התרומה שלך";}
	label[for="dedication"]:after {content:"הקדשׁה";}
	label[for="recipientName"]:after {content:"שם הנמען";}
	label[for="recipientEmail"]:after {content:"אימייל של נמען ";}
	label[for="honoreeName"]:after {content:"שם המכובד";}
	label[for="dedicationMessage"]:after {content:" הודעת הקדשה";}

}
</style>
